// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__AbSEV","actions":"GroupTable_actions__3Rxtu","deleteModalFooter":"GroupTable_deleteModalFooter__2DFpk"};